import {
    LineChartReportTicketAggregate
} from "@dropDesk/domain/entities/reports/report_ticket_aggregate/line_chart_report_ticket_agreggate";
import {
    ComparativeTexts
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";

export class ReportTicketAggregateEntity {
    lineChartClientsAggregate !: LineChartReportTicketAggregate[];
    lineChartSectorsAggregate!: LineChartReportTicketAggregate[];
    lineChartUsersAggregate!: LineChartReportTicketAggregate[];
    lineChartDescriptionsStaticAggregate!: LineChartReportTicketAggregate[];
    timeFirstResponseAggregate!: number;
    timeResolutionAggregate!: number;
    totalTickets!: number;
    averageRating!: number;
    ticketsInBusinessHour!: number;
    ticketsOutBusinessHour!: number;
    texts!: ComparativeTexts;

    static fromJson(json: Record<string, any>): ReportTicketAggregateEntity {
        return new ReportTicketAggregateEntity({
            lineChartClientsAggregate: json['lineChartClientsAggregate'].map((entry: any) => LineChartReportTicketAggregate.fromJson({
                ...entry,
            })),
            lineChartSectorsAggregate: json['lineChartSectorsAggregate'].map((entry: any) => LineChartReportTicketAggregate.fromJson({
                ...entry,
            })),
            lineChartUsersAggregate: json['lineChartUsersAggregate'].map((entry: any) => LineChartReportTicketAggregate.fromJson({
                ...entry,
            })),
            lineChartDescriptionsStaticAggregate: json['lineChartDescriptionsStaticAggregate'].map((entry: any) => LineChartReportTicketAggregate.fromJson({
                ...entry,
            })),
            timeFirstResponseAggregate: json['timeFirstResponseAggregate'] as number,
            timeResolutionAggregate: json['timeResolutionAggregate'] as number,
            totalTickets: json['totalTickets'] as number,
            averageRating: json['averageRating'] as number,
            ticketsInBusinessHour: json['ticketsInBusinessHour'] as number,
            ticketsOutBusinessHour: json['ticketsOutBusinessHour'] as number,
            texts: ComparativeTexts.fromJson(json['texts'] ?? {}),
        })
    }

    constructor({
                    lineChartClientsAggregate,
                    lineChartSectorsAggregate,
                    lineChartUsersAggregate,
                    lineChartDescriptionsStaticAggregate,
                    timeFirstResponseAggregate,
                    timeResolutionAggregate,
                    totalTickets,
                    averageRating,
                    ticketsInBusinessHour,
                    ticketsOutBusinessHour,
                    texts
                }: {
        lineChartClientsAggregate: LineChartReportTicketAggregate[];
        lineChartSectorsAggregate: LineChartReportTicketAggregate[];
        lineChartUsersAggregate: LineChartReportTicketAggregate[];
        lineChartDescriptionsStaticAggregate: LineChartReportTicketAggregate[];
        timeFirstResponseAggregate: number;
        timeResolutionAggregate: number;
        totalTickets: number;
        averageRating: number;
        ticketsInBusinessHour: number;
        ticketsOutBusinessHour: number;
        texts: ComparativeTexts;
    }) {
        Object.assign(this, {
            lineChartClientsAggregate,
            lineChartSectorsAggregate,
            lineChartUsersAggregate,
            lineChartDescriptionsStaticAggregate,
            timeFirstResponseAggregate,
            timeResolutionAggregate,
            totalTickets,
            averageRating,
            ticketsInBusinessHour,
            ticketsOutBusinessHour,
            texts
        });
    }
}
